/**
 * 用户信息相关 API
 */

import http from '~/utils/http'
import type { HttpResponse, RequestConfig } from '~/types/http'
import type { GetInfoResponse, UpdateInfo } from '~/types/auth'

/**
 * 获取用户信息
 */
export async function getInfo(config?: Partial<RequestConfig>): Promise<HttpResponse<GetInfoResponse>> {
  return http.get('/user/getInfo', {
    showSuccess: false,
    loading: false,
    ...config
  })
}

/**
 * 更新用户信息
 */
export async function updateInfo(params: UpdateInfo, config?: Partial<RequestConfig>): Promise<HttpResponse> {
  return http.post('/user/update_hw', params, {
    showSuccess: true,
    loading: true,
    ...config
  })
}
